<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="pt-2">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'sundry-slow-stock-report'" :filters="filters" />
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="filters['search']"
              class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table id="sundry-item-predicted-use-report" :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items" sort :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="code">ITEM CODE</vs-th>
                <vs-th width="10%">ITEM NAME</vs-th>
                <vs-th >BATCH NUMBER</vs-th>
                <vs-th >PO NUMBER</vs-th>
                <vs-th >STOCK QTY</vs-th>
                <vs-th >LAST MOVEMENT DATE</vs-th>
                <vs-th >EXP DATE</vs-th>
                <vs-th width="5%">DAYS IN STOCK</vs-th>
                <vs-th width="5%">STOCK USED (LAST 3 MONTHS)</vs-th>
                <vs-th width="5%">STOCK USED (LAST 4-6 MONTHS AGO)</vs-th>
                <vs-th width="5%">STOCK USED (OVER 9 MONTHS AGO)</vs-th>
                <vs-th >SUPPLIER</vs-th>
                <vs-th >PRIORITY</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="font-semibold text-primary" :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_item_name">
                    {{ data[indextr].sundry_item_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_batch_no">
                    {{ data[indextr].supplier_batch_no || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].po_no">
                    {{ data[indextr].po_no }}
                  </vs-td>

                  <vs-td :data="data[indextr].available_quantity">
                    {{ data[indextr].available_quantity }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_movement_date">
                    {{ __dateTimeFormatterToDate(data[indextr].last_movement_date) }}
                  </vs-td>

                  <vs-td>
                    -
                  </vs-td>

                  <vs-td :data="data[indextr].days_in_stock">
                    {{ data[indextr].days_in_stock }}
                  </vs-td>

                  <vs-td :data="data[indextr].stock_used_last_3_months">
                    {{ data[indextr].stock_used_last_3_months }}
                  </vs-td>

                  <vs-td :data="data[indextr].stock_used_4_8_months">
                    {{ data[indextr].stock_used_4_8_months }}
                  </vs-td>

                  <vs-td :data="data[indextr].stock_used_over_9_months">
                    {{ data[indextr].stock_used_over_9_months }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier">
                    {{ data[indextr].supplier }}
                  </vs-td>

                  <vs-td :data="data[indextr].priority">
                    {{ data[indextr].priority }}
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const sundrySupplierRepository = RepositoryFactory.get('sundry')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'SlowStockReportTable',
  data() {
    return {
      items: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    'v-select': vSelect
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  async mounted() {
  },
  methods: {
    async refreshData() {
      this.fetchSundryItemsUseReportDetails()
    },
    async fetchSundryItemsUseReportDetails() {
      await this.$vs.loading({
        container: '#sundry-item-predicted-use-report',
        scale: 0.45
      })
      try {
        const { data } = await sundrySupplierRepository.getSundryItemsSlowStockReportDetails(this.page, this.filterQuery, this.perPage)
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.showWarningMessage('Something went wrong. Please try again!')
      }
      this.$vs.loading.close('#sundry-item-predicted-use-report > .con-vs-loading')
    },

    filterQueryUpdate() {
      this.fetchSundryItemsUseReportDetails()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchSundryItemsUseReportDetails()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchSundryItemsUseReportDetails()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  watch: {
    page() {
      this.fetchSundryItemsUseReportDetails()
    },
    perPage() {
      this.fetchSundryItemsUseReportDetails()
    }
  }
}
</script>


<style scoped>
.user-edit-popup>>>.vs-popup {
  min-height: 50% !important;
  min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
  .user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
  }
}
</style>
